import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, CheckCircle } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { landingPagesApi } from '@/api/landingPages';

export default function ThankYouPage() {
  const { slug } = useParams<{ slug: string }>();

  const { data: page } = useQuery({
    queryKey: ['landing-page', slug],
    queryFn: () => landingPagesApi.getBySlug(slug!),
    enabled: !!slug,
    staleTime: 60_000,
  });

  const heading = page?.theme?.thank_you_title || "You're on the list!";
  const message = page?.theme?.thank_you_message || "We'll review your application and be in touch soon.";

  return (
    <div className="flex min-h-screen items-center justify-center bg-white px-4 py-16 text-gray-900">
      <main className="w-full max-w-lg text-center">
        <CheckCircle className="mx-auto h-16 w-16 text-indigo-600" aria-hidden="true" />
        <h1 className="mt-6 text-3xl font-bold tracking-tight text-gray-950">{heading}</h1>
        <p className="mt-3 text-base leading-7 text-gray-600">{message}</p>
        <Link
          to={`/join/${slug}`}
          className="mt-8 inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden="true" />
          Back to home
        </Link>
      </main>
    </div>
  );
}
